<div *ngIf="bp">
	@if (istPunktartMitProtokoll(bp.type)) {
		<bp-bohrpunkt-allgemein [bp]="bp" [printView]="true"></bp-bohrpunkt-allgemein>
		<bp-bohrpunkt-boden [bp]="bp" [printView]="true"></bp-bohrpunkt-boden>
		<bp-bohrpunkt-weitere [bp]="bp" [printView]="true"></bp-bohrpunkt-weitere>
		<bp-bohrpunkt-vegetation [bp]="bp" [printView]="true"></bp-bohrpunkt-vegetation>
	}
	@else {
		<bp-bohrpunkt-kurzprotokoll [bp]="bp" [printView]="true"></bp-bohrpunkt-kurzprotokoll>
	}
</div>
